import React from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useTranslation } from "react-i18next";

const TierListOptions = (props) => {
  const { t } = useTranslation();
  const theme = props.basicFunctions.getTheme();
  const { setAlbums, setHaveNames, haveNames, resetGrid, setArtists, setSongs, setTiers } =
    props;
  const { listType, albumList, artistList, songList, initialTiers, customItems } = props.state;
  const { gridSize, onGridSizeChange } = props;

  const isGridPage = !!onGridSizeChange;
  const tierListTypes = isGridPage ? ["Albums", "Artists", "Year"] : ["Albums", "Artists", "Year", "Songs"];
  return (
    <Box
      id="tier-list-options"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        // On the grid page this row sits directly under the header, so it needs
        // its own breathing room and has to line up with the padding of the
        // grid box below it. On the tier list page the surrounding box already
        // provides both.
        pt: isGridPage ? 2.5 : 0,
        px: isGridPage ? 3 : 0,
        pb: "8px",
        gap: "10px",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox checked={haveNames} onChange={() => setHaveNames(!haveNames)} color="primary" />
        }
        label={t("tierList.enableNames")}
      />

      <Typography sx={{ color: "var(--text-primary)" }} variant="h6">
        {t("tierList.listType")}
      </Typography>
      <FormControl>
        <Select
          sx={{
            height: "36px",
          }}
          value={listType}
          onChange={(e) => {
            const newListType = e.target.value;
            props.tierListFunctions.changeListType(newListType);
            setAlbums([...(customItems?.Albums || []), ...albumList]);
            setArtists([...(customItems?.Artists || []), ...artistList]);
            if (setSongs) setSongs([...(customItems?.Songs || []), ...(songList || [])]);
            if (setTiers) {
              setTiers(initialTiers);
            } else {
              resetGrid();
            }

          }}
        >
          {tierListTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {t(`tierList.${type.toLowerCase()}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {onGridSizeChange && (
        <>
          <Typography sx={{ color: "var(--text-primary)" }} variant="h6">
            {t("grid.gridTypeLabel")}
          </Typography>
          <FormControl>
            <Select
              sx={{
                height: "36px",
              }}
              value={gridSize}
              onChange={(e) => onGridSizeChange(parseInt(e.target.value, 10))}
            >
              <MenuItem value={3}>{t("grid.gridTypeOptions.three")}</MenuItem>
              <MenuItem value={4}>{t("grid.gridTypeOptions.four")}</MenuItem>
              <MenuItem value={5}>{t("grid.gridTypeOptions.five")}</MenuItem>
            </Select>
          </FormControl>
        </>
      )}
      <Button
        variant="contained"
        startIcon={<CameraAltIcon />}
        sx={{
          height: "36px",
          textTransform: "none",
          backgroundColor: "var(--accent)",
          "&:hover": { backgroundColor: "var(--accent-hover)" },
        }}
        onClick={() => {
          props.tierListFunctions.captureScreenshot(theme);
        }}
      >
        {t("tierList.captureScreenshot")}
      </Button>
    </Box>
  );
};

export default TierListOptions;
